export default __webpack_public_path__ + "static/media/nw.be7856a6.svg";